import { render, staticRenderFns } from "./SingleCmsPage.vue?vue&type=template&id=69482ed4&scoped=true"
import script from "./SingleCmsPage.vue?vue&type=script&lang=js"
export * from "./SingleCmsPage.vue?vue&type=script&lang=js"
import style0 from "./SingleCmsPage.vue?vue&type=style&index=0&id=69482ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69482ed4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/LoadingSpinner.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
